const shadowHeader = () => {
    if($(window).scrollTop() < 100) {
        $('.header').removeClass('header--scroll');
    } else {
        $('.header').addClass('header--scroll');
    }
}

$(document).ready(function() {
    shadowHeader()
});

$(document).scroll(function() {
    shadowHeader()
});
